<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-wrap">
          <div
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >{{information.label}} {{information.menu}}</div>

          <div class="flex flex-col w-full pl-4">
            <form class="w-full max-w-lg" id="RaisingReportForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3 mb-3">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="report"
                  >Reporte *</label>
                  <textarea
                    class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                    id="report"
                    type="text"
                    name="report"
                    v-model="report"
                  />
                  <p
                    v-if="errors.report"
                    class="text-red-500 text-xs italic text-left"
                  >Escriba un reporte.</p>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveStatusRaising()"
                >Guardar</button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >Cerrar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Actualización de levantamiento exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";
import moment from "moment";

export default {
  name: 'user-raising-modal',
  data() {
    return {
      report: null,
      information: null,
      errors: {
        report: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    EventBus.$on("statusModal", this.setData);
  },
  components: {
    AlertDialog
  },
  methods: {
    reset: function() {
      this.report = null,
      this.information = null
      this.errors = {
        report: false,
        codeError: "Ha ocurrido un error"
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    setData(data) {
      this.information = Object.assign({}, data);
    },

    saveStatusRaising() {
      const form = document.getElementById("RaisingReportForm");
      const signInData = new FormData(form);
      const validForm = this.checkFormSelectAuthority(signInData);

      if (validForm) {
        this.$root.$emit("showLoading");
        let url='';
        if(this.information.menu == 'LEVANTAMIENTO'){
          if(this.information.is_curador){
            url = `../apidev/levantamientos/report/${this.information.raising_id}`
          }else{
            url = `../apidev/levantamientos/userReport/${this.information.raising_id}`
          }
        }else{
          if(this.information.is_curador){
            url = `../apidev/projects/report/${this.information.raising_id}`
          }else{
            url = `../apidev/projects/userReport/${this.information.raising_id}`
          }
        }

        this.axios
            .put(
              url,
              {
                "user_id": localStorage.getItem("user_id"),
                "report": this.report,
              },
              this.config
            )
            .then(() => {
              this.$root.$emit("hideLoading");
              this.showingSuccess = true; 
              this.$emit("updateAllChat");
              this.close()
            })
            .catch(error => {
              this.catchError(error);
              this.showingError = true;
            });
      }
    },

    checkFormSelectAuthority: function(signInData) {
      this.errors.report = signInData.get("report").trim() === "" ? true : false;
      return this.errors.report ? false : true;
    },

    catchError(error){
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
